export default function reducer(
    state = {
        status: "",
        error: null
    },
    action
) {
    switch (action.type) {
        case "CLEAR_STORE":
            state = defaultState()
            break;
        case "WEB_INITIALIZATION_PENDING":
            state = {
                ...state,
                error: null,
                status: "WEB_INITIALIZATION_PENDING"
            }
            break;
        case "WEB_INITIALIZATION_FULFILLED":
            state = {
                ...state,
                error: null,
                status: "WEB_INITIALIZATION_FULFILLED",
            }
            break;
        case "WEB_INITIALIZATION_REJECTED":
            state = {
                ...state,
                error: action.payload.error,
                status: "WEB_INITIALIZATION_REJECTED",
            }
            break;
        default:
            return state;
    }
    return state;
}

function defaultState() {
    return {
        status: "",
        error: null
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/_web.js